import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'spa-apps-sidebar-software-classic.menu.footer.title',
		defaultMessage: "You're in a company-managed project",
		description: 'This is what the user sees when they are on a next-gen project',
	},
	learnMore: {
		id: 'spa-apps-sidebar-software-classic.menu.footer.learn-more',
		defaultMessage: 'Learn more',
		description: 'Link that opens a help article on next-gen projects.',
	},
	learnMoreAriaLabel: {
		id: 'spa-apps-sidebar-software-classic.menu.footer.learn-more-aria-label',
		defaultMessage: 'Learn more about team-managed and company-managed projects',
		description:
			'Descriptive hidden label for the link that opens a help article on next-gen projects.',
	},
});
